import { clsx, type ClassValue } from "clsx";

/**
 * Une clases condicionales con clsx. Helper compartido por los primitivos de
 * UI (`components/ui`). No hace merge de conflictos de Tailwind: el orden de
 * los argumentos manda (la última gana), así que pasa los overrides al final.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
